module.exports = __webpack_public_path__ + "static/pnr-footer-logo-72a002ce38a3410b048c1adb9bda8e72.svg";